import { useEffect, useState } from "react";
import { History } from "lucide-react";
import { api } from "../../lib/api";

const opts = { withCredentials: true };

export const StockHistory = ({ points, refreshKey }) => {
  const [pid, setPid] = useState("");
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/admin/stock/moves", { ...opts, params: pid ? { pickup_id: pid } : {} }).then((r) => setItems(r.data)).catch(() => {}); }, [pid, refreshKey]);
  return (
    <div data-testid="stock-history" className="mt-8">
      <div className="flex flex-wrap items-center gap-3 mb-3">
        <h4 className="font-serif text-xl font-light flex items-center gap-2"><History size={17} className="text-[#2C402E]" /> Historique des entrées et sorties</h4>
        <select value={pid} onChange={(e) => setPid(e.target.value)} data-testid="stock-history-filter" className="bg-[#FAF9F6] border border-[#D1CFC7] px-2 py-1.5 text-xs">
          <option value="">Toutes les librairies</option>
          {points.map((p) => <option key={p.id} value={p.id}>{p.name} ({p.city})</option>)}
        </select>
      </div>
      {items.length === 0 ? <p data-testid="stock-history-empty" className="text-xs text-[#757575]">Aucun mouvement pour l'instant.</p> : (
        <div className="overflow-x-auto border border-[#D1CFC7] max-h-[360px] overflow-y-auto">
          <table className="w-full text-xs whitespace-nowrap">
            <thead className="bg-[#F4F1EA] text-left text-[#4A4A4A] sticky top-0">
              <tr>{["Date", "Librairie", "Livre", "Mouvement", "Stock après", "Motif"].map((h) => <th key={h} className="p-2.5">{h}</th>)}</tr>
            </thead>
            <tbody>
              {items.map((m, i) => (
                <tr key={i} data-testid={`stock-move-${i}`} className="border-t border-[#E8E4D9]">
                  <td className="p-2.5">{new Date(m.at).toLocaleString("fr-FR", { dateStyle: "short", timeStyle: "short" })}</td>
                  <td className="p-2.5">{m.point}</td>
                  <td className="p-2.5 max-w-[200px] truncate">{m.title}</td>
                  <td className={`p-2.5 font-semibold ${m.delta < 0 ? "text-[#9E4735]" : "text-[#2C402E]"}`}>{m.delta > 0 ? `+${m.delta}` : m.delta}</td>
                  <td className="p-2.5">{m.quantity_after}</td>
                  <td className="p-2.5">{m.reason}{m.order_ref ? ` · ${m.order_ref}` : ""}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};
